import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=32d3c9c8&scoped=true&"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js&"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrganisationSelector.vue?vue&type=style&index=1&id=32d3c9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d3c9c8",
  null
  
)

export default component.exports